import {useSyncExternalStore} from "react";
import MiniEvent from "../mini-event";

type Dimension = {
  width: number;
  height: number;
};

let _events: MiniEvent<Dimension>;
let _currVal: Dimension;

const getDims = () => {
  if (!_events) {
    _events = new MiniEvent();
    _currVal = {
      width: document.documentElement.clientWidth,
      height: document.documentElement.clientHeight,
    };
    window.addEventListener("resize", () => {
      _currVal = {
        width: document.documentElement.clientWidth,
        height: document.documentElement.clientHeight,
      };
      _events.emit(_currVal);
    });
  }
  return _currVal;
};
const onUpdate = (fn: () => void) => _events.addListener(fn);

const useWindowSize = () => {
  return useSyncExternalStore(onUpdate, getDims);
};

export default useWindowSize;
